export function getUsersById(state) {
  return state.admin.users;
}

export function selectUserRoles(state) {
  return state.admin.users.roles;
}
